import { InputHTMLAttributes, forwardRef, ReactNode } from "react";
import { clsx } from "clsx";

import { useFieldContext } from "./Field";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  hasError?: boolean;
  label?: ReactNode;
}

const baseClasses = "form-checkbox h-5 w-5 text-dobu-orange border-gray-300 focus:ring-dobu-orange rounded";
const errorClasses = "text-red-500 border-red-500 focus:ring-red-500";

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, hasError: hasErrorProp, id: idProp, label, ...props }, ref) => {
    const { hasError: hasErrorContext, id: idContext } = useFieldContext();
    const hasError = hasErrorProp ?? hasErrorContext ?? false;
    const id = idProp ?? idContext;

    const checkbox = (
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className={clsx(baseClasses, hasError && errorClasses, className)}
        {...props}
      />
    );

    if (!label) {
      return checkbox;
    }

    return (
      <label htmlFor={id} className="flex items-center cursor-pointer">
        {checkbox}
        <span className="text-sm font-medium text-gray-500 ml-2">{label}</span>
      </label>
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
